import type { ReactNode } from "react";
import { createPortal } from "react-dom";

type DSOverlayPortalProps = {
  children: ReactNode;
  open: boolean;
};

function DSOverlayPortal({ children, open }: DSOverlayPortalProps) {
  if (!open || typeof document === "undefined") {
    return null;
  }

  return createPortal(children, document.body);
}

export { DSOverlayPortal };
